import React from 'react';
import PropTypes from 'prop-types';
import { ListItem } from '../../atoms';
import { StyledList, ListHeader } from './styles.js';

export const List = ({ heading, items, icon }) => {
  return (
    <>
      {heading && <ListHeader>{heading}</ListHeader>}
      <StyledList>
        {items.map((item, index) => (
          <ListItem
            heading={item.heading}
            body={item.body}
            icon={icon}
            key={index}
          />
        ))}
      </StyledList>
    </>
  );
};
List.displayName = 'List';
List.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      body: PropTypes.string,
    }),
  ).isRequired,
  heading: PropTypes.string,
  icon: PropTypes.string,
};
